// extracted by mini-css-extract-plugin
export default {"quality":"_styles_quality__SQijI","whatsapp_link":"_styles_whatsapp_link__6WZnf","experience":"_styles_experience__3EQtg"};